import { inject, Injectable } from '@angular/core';
import {
  Interaction,
  InteractionFilterMode,
  InteractionStatus,
} from '../../../models/interactions.model';
import { ConfirmHandler } from '../../dialog/dialog.model';
import { DialogService } from '../../dialog/dialog.service';
import { InteractionSelectionDialogComponent } from '../interaction-selection-dialog.component';

export interface InteractionSelectionDialogData {
  clientId?: string | null;
  multiple?: boolean;
  status?: InteractionStatus[];
  mode?: InteractionFilterMode;
  includeShared?: boolean;
  initialSelectionCount?: number;
  maxSelectionLimit?: number;
  exclude?: (value: Interaction) => boolean;
  allowCreate?: boolean;
  storageKey?: string;
}

@Injectable({
  providedIn: 'root',
})
export class InteractionSelectionDialogService {
  private readonly _dialog = inject(DialogService);

  open(
    callback: ConfirmHandler<Interaction[]>,
    options: {
      clientId?: string | null;
      multiple?: boolean;
      status?: InteractionStatus[];
      mode?: InteractionFilterMode;
      includeShared?: boolean;
      maxSelectionLimit?: number;
      initialSelectionCount?: number;
      exclude?: (value: Interaction) => boolean;
      allowCreate?: boolean;
      storageKey?: string;
    }
  ) {
    return this._dialog.open(
      InteractionSelectionDialogComponent,
      {
        clientId: options.clientId,
        multiple: options.multiple,
        status: options.status,
        mode: options.mode,
        includeShared: options.includeShared,
        maxSelectionLimit: options.maxSelectionLimit,
        initialSelectionCount: options.initialSelectionCount,
        exclude: options.exclude,
        allowCreate: options.allowCreate,
        storageKey: options.storageKey,
        onConfirm: callback,
      },
      {
        maxWidth: '560px',
        width: '100%',
      }
    );
  }
}
